import { Factory, Layers, Check, Sparkles } from "lucide-react";

const HIGHLIGHTS = [
    "Precisão dimensional",
    "Resistência estrutural",
    "Alto padrão de acabamento",
];

const PROCESSOS = [
    "Corte a laser de alta precisão",
    "Dobra CNC",
    "Usinagem",
    "Soldagem técnica",
    "Caldeiraria leve",
    "Montagem de conjuntos metálicos",
];

export const ProblemSolution = () => {
    return (
        <section
            id="solucao"
            data-testid="problem-solution-section"
            className="bg-white section-pad"
        >
            <div className="container-buzas">
                <div className="max-w-3xl mb-14">
                    <span className="eyebrow text-buzas-red">
                        Soluções industriais
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-buzas-navy leading-tight">
                        Da engenharia à entrega final, transformamos projetos
                        em soluções industriais eficientes.
                    </h2>
                    <p className="mt-5 text-base md:text-lg text-buzas-navy/70 leading-relaxed">
                        Atuamos lado a lado com nossos clientes no
                        desenvolvimento de peças, estruturas e componentes que
                        garantem desempenho, produtividade e confiabilidade
                        para operações industriais.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
                    {/* About card */}
                    <article
                        data-testid="problem-card"
                        className="relative bg-white rounded-sm border border-buzas-gray-200 p-8 md:p-10 shadow-sm hover:shadow-md transition-shadow"
                    >
                        <div className="flex items-center gap-2">
                            <Sparkles className="h-4 w-4 text-buzas-red" />
                            <span className="eyebrow text-buzas-red">
                                Componentes metálicos sob medida
                            </span>
                        </div>
                        <h3 className="mt-5 text-2xl md:text-3xl font-bold text-buzas-navy leading-tight">
                            Precisão, resistência e padrão em cada projeto.
                        </h3>
                        <p className="mt-4 text-base text-buzas-navy/70 leading-relaxed">
                            A Buzas desenvolve e fabrica componentes metálicos
                            sob medida para fabricantes de máquinas e
                            equipamentos industriais, entregando precisão,
                            resistência e alto padrão de acabamento em cada
                            projeto.
                        </p>

                        <ul className="mt-6 space-y-3">
                            {HIGHLIGHTS.map((item) => (
                                <li
                                    key={item}
                                    className="flex items-start gap-3 text-sm md:text-base text-buzas-navy/85"
                                >
                                    <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-buzas-red/10 text-buzas-red">
                                        <Check
                                            className="h-3 w-3"
                                            strokeWidth={3}
                                        />
                                    </span>
                                    <span className="font-semibold">
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </article>

                    {/* Production card (dark) */}
                    <article
                        data-testid="solution-card"
                        className="relative bg-buzas-navy rounded-sm p-8 md:p-10 shadow-sm text-white overflow-hidden"
                    >
                        <div
                            aria-hidden
                            className="absolute -top-24 -right-24 h-56 w-56 rounded-full bg-buzas-red/20 blur-3xl"
                        />
                        <div className="relative">
                            <div className="flex items-center gap-2">
                                <Factory className="h-4 w-4 text-white" />
                                <span className="eyebrow text-white/80">
                                    Estrutura produtiva
                                </span>
                            </div>
                            <h3 className="mt-5 text-2xl md:text-3xl font-bold leading-tight">
                                Atende demandas de diferentes níveis de
                                complexidade.
                            </h3>
                            <p className="mt-4 text-base text-white/75 leading-relaxed">
                                Processos integrados em um único parque fabril,
                                do desenho técnico à montagem final.
                            </p>

                            <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                                {PROCESSOS.map((item) => (
                                    <li
                                        key={item}
                                        className="flex items-start gap-3 text-sm md:text-base"
                                    >
                                        <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white text-buzas-navy">
                                            <Layers
                                                className="h-3 w-3"
                                                strokeWidth={3}
                                            />
                                        </span>
                                        <span className="font-semibold">
                                            {item}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </article>
                </div>
            </div>
        </section>
    );
};
